import { getRndKey, camelToKebabCase, sortObjectByKey } from './utils';

export const defaultCol = {
    content: {
        tag: 'div',
        html: '<p>TEXT</p>',
        style: {},
    },
    style: {},
};

export const createBlock = (cols = [{}], extra = {}) => {
    const initCols = [];

    /* LAST WORKING
    cols.map((col) => {
        if (typeof col === 'object' && Object.keys(col).length > 0) {
            initCols.push(col);
        } else {
            initCols.push(defaultCol);
        }
    }); */
    cols.forEach((col) => {
        if (typeof col === 'object' && Object.keys(col).length > 0) {
            initCols.push(col);
        } else {
            initCols.push(defaultCol);
        }
    });
    return createRows([
        {
            cols: initCols,
            extra: extra,
        },
    ]);
};

export const insertBlock = (templateModel, rowId, rowData, insertBefore = false) => {
    const activeRowIndex = findRowIndexById(templateModel, rowId);
    addRowsAt(templateModel, insertBefore === false ? activeRowIndex + 1 : activeRowIndex, rowData);
};

export const createRows = (data = []) => {
    const rows = [];
    for (let i in data) {
        let row = defaultRowModel(data[i]);
        row.cols = addCols(data[i].cols, row.id);
        rows.push(row);
    }
    return rows;
};

export const addRows = (templateModel, rows) => {
    for (let i in rows) {
        templateModel.template.body.push(rows[i]);
    }
    return templateModel;
};

export const addRowsAt = (templateModel, index, rows) => {
    if (index < 0) {
        index = 0;
    }
    if (index >= templateModel.template.body.length) {
        index = templateModel.template.body.length;
    }
    for (let i in rows) {
        // LAST WORKING rows[i].tag = rows[i].tag.replace(/<|>/gi, '');
        rows[i].tag = rows[i].tag.replace(/[<>]/g, '');
        templateModel.template.body.splice(index, 0, rows[i]);
    }
    return templateModel;
};

export const addCols = (cols, rowId) => {
    const result = [],
        count = cols.length;
    // compute default width based on columnb count
    let width = Math.floor(100 * (1 / count) * 100) / 100 - 0.01;
    for (let i in cols) {
        // LAST WORKING cols[i].tag = !cols[i].tag ? 'div' : cols[i].tag.replace(/<|>/gi, '');
        cols[i].tag = !cols[i].tag ? 'div' : cols[i].tag.replace(/[<>]/g, '');
        cols[i].style = !cols[i].style ? {} : cols[i].style;
        /* Override from external data
        cols[i].style.width = !cols[i].style.width
            ? `${width}%`
            : cols[i].style.width; */
        cols[i].style.width = `${width}%`;
        let col = defaultColModel(cols[i], rowId);
        if (cols.length === 1) {
            col.style.float = 'none';
        } else {
            col.style.float = 'left';
        }
        result.push(col);
    }
    return result;
};

export const defaultRowModel = (data = {}) => {
    if (data.tag) {
        // LAST WORKING data.tag = data.tag.replace(/<|>/gi, '');
        data.tag = data.tag.replace(/[<>]/g, '');
    }

    return {
        tag: data.tag || 'div',
        id: data.id || `tpl-row-${getRndKey(10)}`,
        cssClass: data.cssClass || 'template-row',
        style: {
            //display: data?.style?.display || 'block',
            //border: data?.style?.border || '1px dashed #ddd',
            //maxWidth: data?.style?.maxWidth || '700px',
            //width: data?.style?.maxWidth || '700px',
            /* LAST WORKING
            margin: data?.style?.margin || '0 auto',
            padding: data?.style?.padding || '0',
            */
            margin: data?.style?.margin || '0 auto',
            padding: data?.style?.padding || '0',
            overflow: 'hidden',
            //height: '100%',
            //minHeight: '100%',
        },
        cols: [],
        extra: {
            placeholder: getRowExtra(data, 'placeholder'),
            prefix: getRowExtra(data, 'prefix'),
            suffix: getRowExtra(data, 'suffix'),
            type: getRowExtra(data, 'type'),
        },
    };
};

export const getRowExtra = (data, key) => {
    if (data.extra && typeof data.extra === 'object') {
        return data.extra[key] || '';
    }
    return '';
};

export const defaultColModel = (data, rowId) => {
    // Requires object
    if (data.tag) {
        // LAST WORKING data.tag = data.tag.replace(/<|>/gi, '');
        data.tag = data.tag.replace(/[<>]/g, '');
    }
    const defaultContent = data.content || {},
        colId = data.id || `tpl-col-${getRndKey(10)}`;
    return {
        tag: data.tag || 'div',
        id: colId,
        rowId: rowId,
        cssClass: data.cssClass || 'template-col',
        style: {
            //display: data?.style?.display || 'block',
            /* LAST WORKING
            width: data?.style?.width || '100%',
            float: data?.style?.float || 'none',
            */
            width: data?.style?.width || '100%',
            float: data?.style?.float || 'none',
            height: '100%',
            minHeight: '100%',
        },
        content: defaultColModelContent(defaultContent, rowId, colId),
    };
};

const initColModelContentStyles = (data) => {
    const defaultStyles = {
        color: 'rgb(0,0,0)',
        backgroundImage: 'none',
        backgroundColor: 'rgb(255, 255, 255)',
        backgroundSize: '100% auto',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'scroll',
        backgroundPositionX: 'left',
        backgroundPositionY: 'top',
        marginTop: '0px',
        marginRight: 'auto',
        marginBottom: '0px',
        marginLeft: 'auto',
        paddingTop: '0px',
        paddingRight: '0px',
        paddingBottom: '0px',
        paddingLeft: '0px',
        height: '100%',
        minHeight: '100%',
        textAlign: 'left',
        fontWeight: 'normal',
        fontStyle: 'normal',
        textDecoration: 'none',
    };

    return Object.keys(defaultStyles).reduce((acc, key) => {
        acc[key] = data?.style?.[key] || defaultStyles[key];
        return acc;
    }, {});
};

export const defaultColModelContent = (data, rowId, colId) => {
    if (data.tag) {
        // LAST WORKING data.tag = data.tag.replace(/<|>/gi, '');
        data.tag = data.tag.replace(/[<>]/g, '');
    }
    const result = {
        tag: data?.tag || 'div',
        id: data?.id || `tpl-col-content-${getRndKey(10)}`,
        rowId: rowId,
        colId: colId,
        cssClass: data?.cssClass || 'template-col-content',
        contentEditable: 'true',
        style: initColModelContentStyles(data),
        inlineStyle: '',
        html: data?.html || '<p>Sample text</p>',
    };
    result.style = sortObjectByKey(result.style);
    result.inlineStyle = extractStyles(result.style);
    return result;
};

export const defaultTemplateModel = (head = {}) => {
    return {
        template: {
            body: [],
            head: head,
        },
        config: {},
        html: '',
    };
};

export const validate = (templateModel) => {
    if (
        !templateModel.template ||
        typeof templateModel.template !== 'object' ||
        templateModel.template === 'null'
    ) {
        templateModel.template = {
            body: [],
            head: {},
        };
    }

    if (!templateModel.template.head || !Array.isArray(templateModel.template.head)) {
        templateModel.template.head = [];
    }

    if (!templateModel.template.body || !Array.isArray(templateModel.template.body)) {
        templateModel.template.body = [];
    }

    if (typeof templateModel.config !== 'object') {
        templateModel.config = {};
    }

    if (typeof templateModel.html !== 'string') {
        templateModel.html = '';
    }

    return templateModel;
};

export const extractStyles = (style = {}) => {
    let result = []; // CSS styles string representation array
    for (let rule in sortObjectByKey(style)) {
        result.push(`${camelToKebabCase(rule)}:${style[rule]};`);
    }
    return result;
};

export const findRowById = (templateModel, rowId = '') => {
    const result = templateModel.template.body.find((e) => {
        return e.id === rowId;
    });
    return typeof result === 'undefined' ? false : result;
};

export const findRowIndexById = (templateModel, rowId = '') => {
    const result = templateModel.template.body.findIndex((e) => {
        return e.id === rowId;
    });
    return result;
};

export const findRow = (templateModel, row = 0) => {
    const result = templateModel.template.body[row] || {};
    return result;
};

export const findCol = (templateModel, row = 0, col = 0) => {
    const result = findRow(templateModel, row).cols[col] || {};
    return result;
};

export const deleteRow = (templateModel, row = 0) => {
    if (
        templateModel.template.body[row] &&
        typeof templateModel.template.body[row] !== 'undefined'
    ) {
        templateModel.template.body.splice(row, 1);
    }
    return templateModel;
};

export const modifyColContent = (templateModel, rowId, colId, html) => {
    const rowResult = templateModel.template.body.findIndex((e) => {
        return e.id === rowId;
    });
    if (rowResult !== false) {
        const colResult = templateModel.template.body[rowResult].cols.findIndex((e) => {
            return e.id === colId;
        });
        if (colResult !== false) {
            templateModel.template.body[rowResult].cols[colResult].content.html = html;
            return templateModel;
        }
    }

    return false;
};

export const useTemplateModel = () => {
    return {
        defaultCol: defaultCol,
        insertBlock: insertBlock,
        createRows: createRows,
        addRows: addRows,
        addRowsAt: addRowsAt,
        addCols: addCols,
        defaultColModelContent: defaultColModelContent,
        defaultColModel: defaultColModel,
        defaultRowModel: defaultRowModel,
        getRowExtra: getRowExtra,
        defaultTemplateModel: defaultTemplateModel,
        extractStyles: extractStyles,
        findRowById: findRowById,
        findRowIndexById: findRowIndexById,
        findRow: findRow,
        findCol: findCol,
        deleteRow: deleteRow,
        modifyColContent: modifyColContent,
    };
};

export default useTemplateModel;
